import React from 'react';

import { useStore } from 'stores';

import InlineHelp from './InlineHelp';

export const SimpleInlineHelp: React.FC = ({children}) =>
{
  const { uiStore } = useStore();
  return <InlineHelp tip={uiStore.labels.help.tip}>{children}</InlineHelp>;
}